import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyAJ9oBDxy_oN6R4nmGixsalj3-GrHIk_EI",
  authDomain: "dranaluisa-f821d.firebaseapp.com",
  projectId: "dranaluisa-f821d",
  storageBucket: "dranaluisa-f821d.firebasestorage.app",
  messagingSenderId: "1073865353400",
  appId: "1:1073865353400:web:2d71cf4eb90be4915fec4d",
  measurementId: "G-HTWZMN6NEV"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const storage = getStorage(app);

export { db, storage };
